function sortSizes(uniqueProductSizes) {
  const sortedSizes = [
    '6',
    '8',
    '10',
    '12',
    '14',
    '16',
    '18',
    '20',
    '35',
    '36',
    '37',
    '38',
    '39',
    '40',
    'Size 6',
    'size 8',
    'Size 8',
    'size8',
    'size 8 size 10',
    'size 10',
    'Size 10',
    'size10',
    'Size10',
    'size 12',
    'size12',
    'size 14',
    'Size 14',
    'size14',
    'Size14',
    'size 16',
    'size 18',
    'size18',
    'size 20',
    'size S',
    'Size S',
    'size M',
    'Size M',
    'size L',
    'Size L',
    'SIZE L',
    'Talla 6',
    'Talla 8',
    'Talla 10',
    'Talla 12',
    'Talla 14',
    'Talla 16',
    'Talla 18',
    'Talla 20',
    'Default Title',
  ].filter((size) => new Set(uniqueProductSizes).has(size));
  return sortedSizes;
}

export { sortSizes };
